




import { defineComponent } from "@vue/composition-api";
import { mapActions, mapGetters } from "vuex";
import { tableHeaders } from "@monorepo/utils/src/variables/projectsData/systemNotificationsList/tableHeaders";
import ToggleTableCells from "@monorepo/uikit/src/components/tableViews/ToggleTableCells.vue";
import { viewUniqKey } from "@monorepo/utils/src/variables/projectsData/eventLog/viewTitle";

export default defineComponent({
  name: "ToggleTableCellsContainer",
  components: {
    ToggleTableCells,
  },
  data() {
    return {
      viewUniqKey,
      tableHeaders,
    };
  },
  computed: {
    ...mapGetters("systemNotificationsList", ["cells"]),
  },
  methods: {
    ...mapActions("systemNotificationsList", ["setCells"]),
  },
});
